import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { EmptyListText } from "@sprout/client-components/dist/EmptyList";
const ActivityPageEmptyList = ()=>{
    return /*#__PURE__*/ _jsxs(EmptyListText, {
        children: [
            "The Activity Feed shows a ",
            /*#__PURE__*/ _jsx("em", {
                children: "timeline of activity from group trees"
            }),
            " ",
            "you have joined. ",
            `It's`,
            " a way to catch up on",
            " ",
            /*#__PURE__*/ _jsxs("em", {
                children: [
                    "everything ",
                    `that's`,
                    " happened."
                ]
            })
        ]
    });
};
export default ActivityPageEmptyList;
